import { render, staticRenderFns } from "./ViewCoupon.vue?vue&type=template&id=c8a8bd06&scoped=true&"
import script from "./ViewCoupon.vue?vue&type=script&lang=js&"
export * from "./ViewCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ViewCoupon.vue?vue&type=style&index=0&id=c8a8bd06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a8bd06",
  null
  
)

export default component.exports